import { FC, useEffect, useState } from "react";

import { Stack, Typography } from "@mui/material";

import type { CustomHeaderProps } from "ag-grid-react";

export const CommitmentsTypeCell: FC<CustomHeaderProps> = (props) => {
  const [totalRowCount, setTotalRowCount] = useState(
    props.api.getDisplayedRowCount(),
  );

  useEffect(() => {
    const updateCount = () =>
      setTotalRowCount(props.api.getDisplayedRowCount());

    props.api.addEventListener("filterChanged", updateCount);
    props.api.addEventListener("rowDataUpdated", updateCount);

    return () => {
      props.api.removeEventListener("filterChanged", updateCount);
      props.api.removeEventListener("rowDataUpdated", updateCount);
    };
  }, [props.api]);

  return (
    <Stack position="relative">
      <Typography variant="body2" fontWeight="medium">
        Type
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {totalRowCount}
      </Typography>
    </Stack>
  );
};
